export default __webpack_public_path__ + "static/media/PMH.5c3175c2.svg";